import React from "react"

export function Arrow() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.79289 18.7071C9.40237 18.3166 9.40237 17.6834 9.79289 17.2929L15.0858 12L9.79289 6.70711C9.40237 6.31658 9.40237 5.68342 9.79289 5.29289C10.1834 4.90237 10.8166 4.90237 11.2071 5.29289L17.2071 11.2929C17.5976 11.6834 17.5976 12.3166 17.2071 12.7071L11.2071 18.7071C10.8166 19.0976 10.1834 19.0976 9.79289 18.7071Z"
        fill="#292929"
      />
    </svg>
  )
}
